import React from 'react';
import PropTypes from 'prop-types';
import { SuperAdminMenu } from './menus-by-role/SuperAdminMenu';
import { AdminMenu } from './menus-by-role/AdminMenu';
import { MyOutsourcesManagerMenu } from './menus-by-role/MyOutsourcesManagerMenu';
import { MyOutsourcesViewerMenu } from './menus-by-role/MyOutsourcesViewerMenu';
import { MyContractorsManagerMenu } from './menus-by-role/MyContractorsManagerMenu';
import { setMenuToggle } from './MenuToggle';
import { MenuContext } from './MenuContext';
import './Menu.css';
import { DocumentaryLibraryMenu } from './DocumentaryLibraryMenu';

export const Menu = (
    {
        currentUser,
    },
) => {
    const contractor = currentUser.contractor();
    const displayTasks = currentUser.showCreateTaskWindow();
    const displayListerias = currentUser.showListerias();
    const displayNewTask = currentUser.canCreateTasks();
    const [currentPathName, setNextPathName] = React.useState(window.location.pathname);

    React.useEffect(() => {
        setMenuToggle();
    }, []);

    return (
        <MenuContext.Provider value={{ currentPathName, setNextPathName }}>
            <div className="menu ps-sidebar-menu">
                {
                    currentUser.hasRole() ? (
                        <ul className="list">
                            {
                                currentUser.isSuperAdmin() ? (
                                    <SuperAdminMenu/>
                                ) : null
                            }
                            {
                                currentUser.isAdmin() ? (
                                    <AdminMenu contractor={contractor}
                                               displayTasks={displayTasks}
                                               displayListerias={displayListerias}
                                               displayNewTask={displayNewTask}
                                    />
                                ) : null
                            }
                            {
                                currentUser.isOutsourcesManager() ? (
                                    <MyOutsourcesManagerMenu contractor={contractor}
                                                             displayTasks={displayTasks}
                                                             displayListerias={displayListerias}
                                    />
                                ) : null
                            }
                            {
                                currentUser.isOutsourcesViewer() ? (
                                    <MyOutsourcesViewerMenu/>
                                ) : null
                            }
                            {
                                currentUser.isContractorsManager() ? (
                                    <MyContractorsManagerMenu/>
                                ) : null
                            }
                            {
                                !currentUser.isSuperAdmin() &&
                                !currentUser.isListeriaManager() ? (
                                    <DocumentaryLibraryMenu currentUser={currentUser}/>
                                ) : null
                            }
                        </ul>
                    ) : null
                }
            </div>
        </MenuContext.Provider>
    );
};

Menu.propTypes = {
    currentUser: PropTypes.object.isRequired,
};

Menu.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/menu/Menu.jsx